import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { CSSZUser } from '../../Interfaces/CSSZ.interface';
import { CSSZSickLeaveValues } from '../CSSZSickLeaveCertificateCreate/CSSZSickLeaveCertificateCreate';
import CSSZSickLeaveCertificateRepair from './CSSZSickLeaveCertificateRepair';

interface Props extends BaseModalProps {
	onSubmit: (values: CSSZSickLeaveValues) => void;
	documentId: string;
	user: CSSZUser;
}

const CSSZSickLeaveCertificateRepairModal = ({
	onSubmit,
	documentId,
	user,
	...baseModalProps
}: Props) => {
	return (
		<BaseModal
			title={'component.CSSZSickLeaveCertificateCreate.modalTitle'}
			{...baseModalProps}>
			<CSSZSickLeaveCertificateRepair
				documentId={documentId}
				onSubmit={onSubmit}
				user={user}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateRepairModal;
